import QuotationRules from '../business-logic/Quotation.rules';

const QuotationAdapter = {
  getReviewQuotationDetailsDto(acceptedActivities, quotationItems) {
    const acceptedQuotationItems = quotationItems.filter(
      (quotationItem) => acceptedActivities.includes(
        quotationItem.order_activity_id,
      ),
    );

    const items = [...acceptedQuotationItems];

    return items.map((quotationItem) => ({
      part_id: quotationItem.part_id,
      pack_id: quotationItem.pack_id,
      pack_id_dms: null,
      pack_desc: quotationItem.pack_desc,
      part_desc: quotationItem.part_desc,
      pack_category: null,
      quotation_id: quotationItem.quotation_id,
      charge_type_id: null,
      accepted: 1,
      ...QuotationRules.isLabour(quotationItem) && {
        labours_id_dms: quotationItem.part_id_dms,
        labours_id: quotationItem.part_id,
        timeUnits: quotationItem.part_quantity,
      },
      ...QuotationRules.isSparepart(quotationItem) && {
        pack_category: 'PA',
        part_id_dms: quotationItem.part_id_dms,
        part_quantity: quotationItem.part_quantity,
      },
      ...QuotationRules.isPpsoItem(quotationItem) && {
        pack_id_dms: quotationItem.pack_id_dms,
        pack_category: quotationItem.pack_category,
        otherCharges: this.getPpsoChargesReviewQuotationDto(quotationItem, acceptedQuotationItems),
        labours: this.getPpsoLaboursReviewQuotationDto(quotationItem, acceptedQuotationItems),
      },
      ...QuotationRules.isAgencyPackageItem(quotationItem) && {
        pack_id_dms: quotationItem.pack_id_dms,
        pack_category: 'DP',
      },
      ...QuotationRules.isOtherCharge(quotationItem) && {
        part_id: quotationItem.part_id,
        pack_id: quotationItem.pack_id,
        pack_id_dms: quotationItem.pack_id_dms,
        pack_desc: quotationItem.pack_desc,
        part_desc: quotationItem.part_desc,
        pack_category: quotationItem.pack_category,
        quotation_id: quotationItem.quotation_id,
        accepted: 1,
        other_charges_id_dms: quotationItem.material_id_dms,
        percentage: quotationItem.percentage,
        cost: quotationItem.material_cost,
        enumCharge: quotationItem.other_charges_type_id,
        fareId: quotationItem.fare_id,
        deferenceId: quotationItem.deferencia,
      },
    }));
  },

  /**
   * Generates a list of  PPSo charges DTO items for reviewQuotation payload.
   * @param {array} ppsoChargesList - The PPSo charges list
   * @returns {array} - The list of PPSo charges DTO items list
   */
  getPpsoChargesReviewQuotationDto(ppsoItem, quotationItems) {
    const ppsoChargesList = quotationItems.filter(
      (quotationItem) => quotationItem.material_desc
        && quotationItem.pack_category === 'PP'
        && quotationItem.pack_id_dms === ppsoItem.pack_id_dms,
    );

    return ppsoChargesList.map((charge) => ({
      otherChargeCode: charge.material_id_dms,
      percentage: charge.percentage,
      enumCharge: charge.other_charges_type_id,
      isIncluded: QuotationRules.isPpsoChargeIncluded(charge),
      total: charge.part_price,
    }));
  },

  /**
   * Generates a list of PPSo labours DTO items for reviewQuotation payload.
   * @param {array} ppsoItem - The PPSo package.
   * @param {array} quotationItems - The quotation items list.
   * @returns {array} - A list of PPSo labours DTO items list.
   */
  getPpsoLaboursReviewQuotationDto(ppsoItem, quotationItems) {
    const ppsoLaboursList = quotationItems.filter(
      (quotationItem) => quotationItem.part_brand === 'manoDeObra'
        && quotationItem.pack_category === 'PP'
        && quotationItem.pack_id_dms === ppsoItem.pack_id_dms,
    );

    return ppsoLaboursList.map((labour) => {
      let { part_quantity: timeUnits } = labour;
      const { part_id_dms: labourCode } = labour;

      timeUnits = Number(timeUnits);

      return {
        labourCode,
        timeUnits,
      };
    });
  },
};

export default QuotationAdapter;
